// Settings + shipping-companies API client (Phase 8).
import { request } from './api';

export const settingsApi = {
    get: () => request('/settings'),
    patch: (body) => request('/settings', { method: 'PATCH', body }),
    // Phase 11.4 — non-sensitive Shopify webhook diagnostic snapshot
    // (secret shape metadata, timestamp of last valid HMAC hit, last 10
    // failures with topic/shop/reason).
    getDiagnostics: () => request('/settings/webhook-diagnostics'),
};

export const shippingCompaniesApi = {
    list: () => request('/shipping-companies'),
    create: (body) => request('/shipping-companies', { method: 'POST', body }),
    update: (id, body) => request(`/shipping-companies/${id}`, { method: 'PATCH', body }),
    remove: (id) => request(`/shipping-companies/${id}`, { method: 'DELETE' }),
    revealCredentials: (id) => request(`/shipping-companies/${id}/credentials`),
};
